export const stickyFocusRenderTypes = ['options', 'multi_options', 'image', 'email'];